<template>
  <pt-doctor-form ref="form" class="pt-doctor-form__withData" :allMembers="allMembers" :doctorDetail="doctorDetail" :isEdit="isEdit" :company="company"
  :hospitalList="hospitalList"></pt-doctor-form>
</template>

<script>
import PtDoctorForm from './form'
import { hasPermissions } from 'utils/permissions'
const PERM_DOCTOR_OPERATION = 'PERM_DOCTOR_OPERATION'// 所有分子公司的增删权限
const PERM_REGION_DOCTOR_OPERATION = 'PERM_REGION_DOCTOR_OPERATION'// 自己所属分子公司的增删权限
export default {
  name: 'pt-doctor-form__withData',
  components: {
    'pt-doctor-form': PtDoctorForm
  },
  computed: {
    form () {
      return this.$refs.form
    },

    HAS_PERM_DOCTOR_OPERATION () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_DOCTOR_OPERATION)
    },
    HAS_PERM_REGION_DOCTOR_OPERATION () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_REGION_DOCTOR_OPERATION)
    }
  },
  props: {
    userLogin: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      organizations: [],
      rolesList: [],
      doctorDetail: {},
      is_dialog: false,
      password: '',
      formValue: {},
      company: [],
      doctorOldmobile: null,
      allMembers: [],
      hospitalList: []
    }
  },
  methods: {
    // 获取全部会员等级列表
    getAllMembers () {
      this.loading = true
      this.$store.dispatch('getAllMembers').then(res => {
        this.loading = false
        this.allMembers = res.data
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取会员等级失败')
      })
    },
    getUserDetail () {
      this.$emit('detailLoading', true)
      this.$store.dispatch('getDoctorDetail', this.$route.params.id).then(res => {
        this.$emit('detailLoading', false)
        this.doctorDetail = res
        this.doctorOldmobile = res.mobile
      }).catch(err => {
        this.$emit('detailLoading', false)
        this.$message.error(err || '获取医生详情失败')
      })
    },
    submit () {
      this.form.validate().then(formValue => {
        this.form.address.address.validate().then(res => {
          this.form.question.validate().then(res => {
            if (!this.isEdit) {
              formValue = { ...formValue, ...formValue.question }
              this.$delete(formValue, 'question')
              this.createDoctor(formValue)
            } else {
              formValue = { ...formValue, ...formValue.question }
              this.$delete(formValue, 'question')
              if (this.doctorOldmobile === formValue.mobile) {
                this.updateDoctor(formValue)
              } else {
                this.getHasMallUser(formValue)
              }
            }
          })
        })
      })
    },
    getHasMallUser (formValue) {
      this.$emit('submitLoading', true)
      this.$store.dispatch('getHasMallUser', formValue.mobile).then(res => {
        this.$emit('submitLoading', false)
        let text = null
        if (res) {
          text = '更改手机号后，新手机号对应的用户账户将升级至医护人员对应的会员等级，原手机号对应的用户账户将被重置到普通用户对应的会员等级，确认更改吗？'
        } else {
          text = '更改手机号后，原手机号用户账户信息将转移至新的手机号账户，确认更改吗？'
        }
        this.$confirm(text, '电话号码修改提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(_ => {
          this.updateDoctor(formValue)
        })
      }).catch(err => {
        this.$emit('submitLoading', false)
        this.$message(err || '查询电话号码失败')
      })
    },
    createDoctor (data) {
      this.$emit('submitLoading', true)
      this.$store.dispatch('createDoctor', data).then(res => {
        this.$emit('submitLoading', false)
        this.$message.success('新建医生成功')
        // history.go(-1)
        this.$router.push('/doctor-manage')
      }).catch(errorMessage => {
        this.$emit('submitLoading', false)
        this.$message.error(errorMessage || '新建医生失败')
      })
    },
    updateDoctor (data) {
      this.$emit('submitLoading', true)
      console.log('data++++', data)
      this.$store.dispatch('updateDoctor', data).then(res => {
        this.$emit('submitLoading', false)
        this.$message.success('编辑医生成功')
        // history.go(-1)
        this.$router.push('/doctor-manage')
      }).catch(err => {
        this.$emit('submitLoading', false)
        this.$message.error(err || '编辑医生失败')
      })
    },
    getHospitalList () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('getHospitalList', data).then(res => {
        this.hospitalList = res.data
      }).catch(err => {
        this.$message.error(err || '获取医院列表失败')
      })
    },
    getCompanyList () {
      let data = {
        type: 'BRANCH',
        pageableParam: {
          page: 0,
          size: 9999
        }
      }
      let organizationId = this.$auth.user().organizationId
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        var newArr = []
        res.data.forEach(ele => {
          var obj = {}
          obj.value = ele.id
          obj.label = ele.fullName
          newArr.push(obj)
        })
        if (this.HAS_PERM_DOCTOR_OPERATION) {
          this.company = newArr
        } else if (this.HAS_PERM_REGION_DOCTOR_OPERATION) {
          newArr.forEach(item => {
            if (item.value === organizationId) {
              this.company.push(item)
            }
          })
        }
      }).catch(err => {
        this.$message.error(err || '获取分/子公司列表失败')
      })
    }
  },
  created () {
    this.getCompanyList()
    this.getHospitalList()
    if (this.isEdit) {
      this.getUserDetail()
    }
    this.getAllMembers()
  }
}
</script>
